export type FirebaseConfigType = {
  apiKey: string;
  authDomain: string;
  databaseURL: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
};

export const firebaseConfig: FirebaseConfigType = {
  apiKey: 'AIzaSyBk1shpUX4j3ES_Y1_iY7G3ahnbbb2z8-g',
  authDomain: 'api-5896211539745406657-217002.firebaseapp.com',
  databaseURL: 'https://api-5896211539745406657-217002.firebaseio.com',
  projectId: 'api-5896211539745406657-217002',
  storageBucket: 'api-5896211539745406657-217002.appspot.com',
  messagingSenderId: '749640423539',
  appId: '',
  measurementId: '',
};
